import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { PageNavigationService } from '../../../shared/services/page-navigation.service';
import { LayoutService } from '../../../shared/services/layout.service';

@Component({
  selector: 'terms-of-use',
  templateUrl: './terms.component.html'
})
export class TermsComponent implements OnInit {

  constructor(
    private _pageNavigationService: PageNavigationService,
    private _layoutService: LayoutService    
  ) { }

  ngOnInit() {
    this._layoutService.setCurrentPage('terms-of-use');
  }
  goToLogin() {
    let vLink:any = ['login'];
    this._pageNavigationService.navigate(vLink);
}
}



// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/information/components/terms/terms.component.ts